import { LegicCredentialRedemptionRequestProviderParams } from '~generated-api/models/legic-credential-redemption-request-provider-params';

export class LegicCredentialRedemptionRequestProviderParamsModel implements LegicCredentialRedemptionRequestProviderParams {
  readonly credentialProvider: string = 'LEGIC_CONNECT';
  readonly googleAud: string;
  readonly googleNonce: string;
  readonly googleUser: string;

  constructor(init: Omit<LegicCredentialRedemptionRequestProviderParams, 'credentialProvider'>) {
    this.googleAud = init.googleAud;
    this.googleNonce = init.googleNonce;
    this.googleUser = init.googleUser;
  }
}
